module.exports = __webpack_public_path__ + "img/icon_withdraw_empty_blue.b20a24c6.svg";